import { render, staticRenderFns } from "./ReferAndWinModal.vue?vue&type=template&id=2850da91"
import script from "./ReferAndWinModal.vue?vue&type=script&lang=js"
export * from "./ReferAndWinModal.vue?vue&type=script&lang=js"
import style0 from "./ReferAndWinModal.vue?vue&type=style&index=0&id=2850da91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports